export default __webpack_public_path__ + "static/media/fevr-bm-icon-2.83bbc45d.svg";